//个人中心
import config from '@/utils/config'
const uApi = {
	/*发送验证码
	入参：
	   smsText: "smsCode"     -----不清楚
	   telephone : 15018084533  ------接受短信号码
	   template:"updatePad"   ------应该是模板吧
	*/
	sendSMSCode: function(postData) {
		return fly.post( config.wapApi + "app/person/sendSMSCode", postData);
	},
	/*发送验证码
	入参：
	   phone
	  type   1用户注册，2忘记登陆密码,3忘记支付密码
	*/
	sendSMSCoded: function(postData) {
		return fly.post( config.commonApi + "common/core/phoneCode", postData);
	},
	/*注册
	入参：
		telephone---手机号码
	    smsCode---验证码
	*/
	register: function(postData) {
		return fly.post( config.wapApi + "app/person/register", postData);
	},
	/*忘记密码
	入参：
		telephone---手机号码
	    smsCode---验证码,
	    password---密码
	    passwordAgain---确认密码
	*/
	forgetLoginPwd: function(postData) {
		return fly.post( config.wapApi + "app/person/forgetLoginPwd", postData);
	},
	/*拍卖登录
	入参：
	 u---账号
	 p---密码
	*/
	login: function(u,p) {
		return fly.post( config.wapApi + "app/person/login", {customerLogin:u,customerPwd:md5(p)});
	},
//	验证码登录   telephone  smsCode
	smsCodeLogin: function(postData) {
		return fly.post( config.wapApi + "app/person/smsCodeLogin", postData);
	},
	/* 获取个人首页信息
	入参：
	customerSeq---用户seq
	*/
	getUser: function(customerSeq) {
		return fly.post( config.wapApi + 'app/person/homepage/' + customerSeq);
	},
  // /* 获取会员中心权益
  // 入参：
  // */
  // getWelfareList: function() {
  // 	return fly.post( config.wapApi + 'app/member/welfare/queryPage');
  // },
	/* 获取用户个人信息
	入参：
	customerSeq---用户seq
	*/
	queryCustomerInfo: function(customerSeq) {
		return fly.get( config.wapApi + 'app/person/queryCustomerInfo/' + customerSeq);
	},
  /* 获取拍卖达人信息
  入参：
  customerSeq---用户seq
  */
  auctionDoyen: function(customerSeq) {
    return fly.get( config.wapApi + 'app/person/auctionDoyen/' + customerSeq);
  },
	/* 修改用户个人信息
	入参：
	customerSeq---用户seq
	//被修改的字段全部非必传，传什么就修改什么
	realName---姓名，
	nickName---昵称，
	autograph---个性签名
	*/
	updateCustomerInfo: function(postData) {
		return fly.post( config.wapApi + 'app/person/updateCustomerInfo', postData);
	},
	/* 绑定邮箱
	入参：
	customerSeq---用户seq
 	customerEmail --- 邮箱
	*/
	postBox: function(postData) {
		return fly.post( config.wapApi + 'app/person/postBox', postData);
	},
	/* 意见反馈
	入参：
	customerSeq---用户seq
 	feedbackContent --- 反馈内容
	*/
	saveFeed: function(postData) {
		return fly.post( config.wapApi + 'app/person/saveFeed', postData);
	},

	/* 拉黑发帖人
	入参：
	uid---发帖用户seq
	*/
	shield: function(uid) {
		return fly.get(config.wapApi + 'app/bbs/post/shield/' + uid);
	},
	/* 我的粉丝
	入参：
	customerSeq---用户seq
 	page   页码
 	rows   数量
	*/
	queryFollowByFollowUid: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/queryFollowByFollowUid', postData);
	},
	/* 我的关注
	入参：
	customerSeq---用户seq
 	page   页码
 	rows   数量
	*/
	queryFollowByUid: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/queryFollowByUid', postData);
	},
	/* 查询威币
	入参：
	customerSeq---用户seq
 	page   页码
 	rows   数量
	*/
	myWallet: function(postData) {
		return fly.post( config.wapApi + 'app/person/myWallet', postData);
	},
	//获取微信配置
	//url   ---  微信配置的回调地址
	getWXConfig(wxUrl){
		return fly.post( config.wapApi + 'app/auction/getWXConfig?url=' + wxUrl);
	},
	//  获取回放视频资料
	getLivePlayBack: function(id) {
		return fly.get(config.wapApi + 'app/bbs/post/live/'+id);
	}
}

export default uApi



// WEBPACK FOOTER //
// ./src/utils/api/uApi.js